import React from 'react';
import PropTypes, { any } from 'prop-types';

import { Form } from 'react-form';
import DebouncedFilterInput from '../../../components/FormElementsStandalone/DebouncedFilterInput';
import { debounce } from '../../../utils/debounceUtil';
import { Select } from '../../../components/Form';

import styles from '../drawEdit.scss';

const CheckInFilters = (props) => {
    const {
        handleFilterDate, handleFilterPlayer, filterPlayerValue, filterDateOptions, filterDateValue, counts,
    } = props;

    const debouncedHandleFilterPlayer = debounce(handleFilterPlayer, 250);

    return (
        <div className={`${styles.section} check-in-filters`}>
            <Form>
                <div className="check-in-container container d-flex">
                    <div className="d-flex">
                        <div className={styles.filterWrapper}>
                            <Select
                                id="date"
                                field="date"
                                options={filterDateOptions}
                                hiddenLabel={true}
                                onChange={handleFilterDate}
                                themeV3
                                formGroupCssClass="bg-white select-input"
                                hiddenDefault={true}
                                value={filterDateValue}
                                data-testid="check-in.filters.date-select"
                            />
                        </div>
                        <div className="search-wrapper">
                            <DebouncedFilterInput
                                value={filterPlayerValue}
                                onChange={debouncedHandleFilterPlayer}
                                placeholder="Find Players"
                                className="search-input pr24"
                                data-testid="check-in.filters.search"
                            />
                        </div>
                    </div>
                    <div className="counts d-flex jsb ml32">
                        <div className="counts-item d-flex flex-col ">
                            <div className="fs11 text-xtra-dark fw500" data-testid="check-in.filters.players-label">PLAYERS</div>
                            <div className="counts-item-number text-xtra-dark fw300" data-testid="check-in.filters.players-count">{counts?.totalPlayers || 0}</div>
                        </div>
                        {counts.checkedInPlayers !== null && (
                            <>
                                <div className="counts-item d-flex flex-col  ml12">
                                    <div className="fs11 text-xtra-dark fw500" data-testid="check-in.filters.checked-in-label">CHECKED IN</div>
                                    <div className="counts-item-number text-xtra-dark fw300" data-testid="check-in.filters.checked-in-count">{counts?.checkedInPlayers || 0}</div>
                                </div>
                                <div className="counts-item d-flex flex-col  ml12">
                                    <div className="fs11 text-xtra-dark fw500" data-testid="check-in.filters.remaining-label">REMAINING</div>
                                    <div className="counts-item-number text-xtra-dark fw300" data-testid="check-in.filters.remaining-count">{counts?.totalPlayers && counts?.checkedInPlayers ? counts.totalPlayers - counts.checkedInPlayers : counts?.totalPlayers}</div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Form>

        </div>
    );
};

CheckInFilters.propTypes = {
    handleFilterDate: PropTypes.func.isRequired,
    handleFilterPlayer: PropTypes.func.isRequired,
    filterDateOptions: PropTypes.arrayOf(any).isRequired,
    filterPlayerValue: PropTypes.string,
    filterDateValue: PropTypes.string,
    counts: PropTypes.objectOf(any),
};

CheckInFilters.defaultProps = {
    filterPlayerValue: '',
    filterDateValue: '',
    counts: {},
};

export default CheckInFilters;
